  fetch('/products.json')
  .then(response => response.json())
  .then(data => {
    window.products = data.products;
    setSearchData();
    setTimeout(() => {
        setSearchData();
        setTimeout(() => {
            setSearchData();
        }, 100);
    }, 100);
  });

    let searchIocn = document.querySelector('.search-icon');
    let sarchForm = document.querySelector('.search-product-form');
    let ProductContainer = document.querySelector('.pro-main-search-container');

  searchIocn.addEventListener('click', function(){
      this.classList.toggle('shows');
      sarchForm.classList.toggle('opened');
  });

  function setSearchData(){
      let product_Html = '';
      let searchesValue = location.search.split('?query=')[1].split(',');
      
      let products = window.products;
      sarchForm.querySelector('input').value = location.search.split('?query=')[1];
      //console.log('search' + location.search.split('?query=')[1]);

        if(!String(location.search.split('?query=')[1]).trim().length){
            document.getElementById('search_product_result').innerHTML = `<h1> No Result Found </h1>`;
        }
      if(searchesValue){
        let searchResult = [];
        if(searchesValue.length == 1){
            //console.log('Search Value ' + searchesValue);
            for(let k = 0; k < searchesValue.length; k++){
                console.log(searchesValue[k]);
                for (const key in products) {
                    for (const variantkey in products[key].variants) {
                        if (products[key].variants[variantkey].available) {
                            if(String(products[key].variants[variantkey].title).toLowerCase().includes(String(searchesValue).toLowerCase().trim()) && products[key].id != 7710472405162 && products[key].id != 7710466867370){
                                product_Html = product_Html + `
                                    <li class="grid__item item-row wide--one-third post-large--one-third large--one-third medium--one-half small--one-half  medium--grid__item small-grid__item  " id="product-6190665990314">
                                        <div class="products product-hover-11">
                                            <div class="product-container">
                                                <a href="/products/${products[key].handle}?variant=${products[key].variants[variantkey].id}" class="grid-link">
                                                    <div class="ImageOverlayCa"></div>
                                                </a>
                                                <div class="reveal"><a href="/products/${products[key].handle}?variant=${products[key].variants[variantkey].id}" class="grid-link"> 
                                                    <span class="product-additional">   
                                                    </span></a>
                                                    <a href="/products/${products[key].handle}?variant=${products[key].variants[variantkey].id}" class="grid-link">  
                                                    <img src="${products[key].variants[variantkey].featured_image.src}" class="featured-image" alt="${products[key].variants[variantkey].title}">
                                                    </a>
                                                </div>
                                                <div class="product_right_tag  ">
                                                </div>
                                                <div class="ImageWrapper">
                                                    <div class="link_icon">
                                                    </div>
                                                    <div class="product-button"> 
                                                    <a title="Product Link" href="/products/${products[key].handle}?variant=${products[key].variants[variantkey].id}">                      
                                                    <i class="fas fa-link"></i> 
                                                    </a>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="product-detail">
                                                <a href="/products/${products[key].handle}?variant=${products[key].variants[variantkey].id}" class="grid-link__title" style="font-size: 90%">${products[key].title}</a>
                                                <a href="/products/${products[key].handle}?variant=${products[key].variants[variantkey].id}" class="grid-link__title">${products[key].variants[variantkey].title}</a>
                                                <span class="shopify-product-reviews-badge" data-id="6190665990314"></span>              
                                                <div class="grid-link__meta">
                                                    <div class="product_price">
                                                    <div class="grid-link__org_price" id="ProductPrice">
                                                        $${products[key].variants[variantkey].price}
                                                    </div>
                                                    </div>
                                                </div>
                                                <ul class="item-swatch">
                                                 
                                                </ul>
                                            </div>
                                        </div>
                                    </li>
                                    `;
                            }    
                        }
                    }
                }
            }
        }else {
            console.log('Else Statment');
            for(let k = 0; k < searchesValue.length; k++){
                console.log(searchesValue[k]);
                for (const key in products) {
                    for (const variantkey in products[key].variants) {
                        if (products[key].variants[variantkey].available) {
                            if(String(products[key].variants[variantkey].title).toLowerCase().includes(String(searchesValue[k]).toLowerCase().trim())){
                                product_Html = product_Html + `
                                    <li class="grid__item item-row wide--one-third post-large--one-third large--one-third medium--one-half small--one-half  medium--grid__item small-grid__item  " id="product-6190665990314">
                                        <div class="products product-hover-11">
                                            <div class="product-container">
                                                <a href="/products/${products[key].handle}?variant=${products[key].variants[variantkey].id}" class="grid-link">
                                                    <div class="ImageOverlayCa"></div>
                                                </a>
                                                <div class="reveal"><a href="/products/${products[key].handle}?variant=${products[key].variants[variantkey].id}" class="grid-link"> 
                                                    <span class="product-additional">   
                                                    </span></a>
                                                    <a href="/products/${products[key].handle}?variant=${products[key].variants[variantkey].id}" class="grid-link">  
                                                        <img src="${products[key].variants[variantkey].featured_image.src}" class="featured-image" alt="${products[key].variants[variantkey].title}">
                                                    </a>
                                                </div>
                                                <div class="product_right_tag  ">
                                                </div>
                                                <div class="ImageWrapper">
                                                    <div class="link_icon">
                                                    </div>
                                                    <div class="product-button"> 
                                                    <a title="Product Link" href="/products/${products[key].handle}?variant=${products[key].variants[variantkey].id}">                      
                                                    <i class="fas fa-link"></i> 
                                                    </a>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="product-detail">
                                                <a href="/products/${products[key].handle}?variant=${products[key].variants[variantkey].id}" class="grid-link__title" style="font-size: 90%">${products[key].title}</a>
                                                <a href="/products/${products[key].handle}?variant=${products[key].variants[variantkey].id}" class="grid-link__title">${products[key].variants[variantkey].title}</a>
                                                <span class="shopify-product-reviews-badge" data-id="6190665990314"></span>              
                                                <div class="grid-link__meta">
                                                    <div class="product_price">
                                                    <div class="grid-link__org_price" id="ProductPrice">
                                                        $${products[key].variants[variantkey].price}
                                                    </div>
                                                    </div>
                                                </div>
                                                <ul class="item-swatch">
                                                 
                                                </ul>
                                            </div>
                                        </div>
                                    </li>
                                    `;
                            }    
                        }
                    }
                }
            }
        }
    }

    if(String(product_Html).trim().length){
        document.getElementById('search_product_result').innerHTML = product_Html;
        document.querySelectorAll('.products .item-swatch li label').forEach(single => {
            single.addEventListener('click', function(){
                single.parentElement.parentElement.parentElement.parentElement.querySelector('.featured-image').src = single.getAttribute('img');
            })
        })
    }else {
        document.getElementById('search_product_result').innerHTML = `<h1> No Result Found </h1>`;
    }

      

      $(document).ready(function() {
          $(".item-swatch").each(function(){ 
          if($(this).children().length == 0){ 
              $(this).remove();        
              } else{
              $(this).show();        
              }
          });
          $(".sizes-list").each(function(){ 
          if($(this).children().length == 0){ 
              $(this).remove();        
              } else{
              $(this).show();        
              }
          });
      });
      //console.log();
      sarchForm.classList.remove('opened');
      ProductContainer.classList.toggle('opened');
  }

  sarchForm.addEventListener('submit', function(e){
      e.preventDefault();
      let product_Html = '';
      let searchesValue = sarchForm.querySelector('input').value.split(',');
      let products = window.products;

      if(searchesValue){
          let searchResult = [];
          if(searchesValue.length == 1){
            //console.log('Search Value ' + searchesValue);
            for(let k = 0; k < searchesValue.length; k++){
                console.log(searchesValue[k]);
                for (const key in products) {
                    for (const variantkey in products[key].variants) {
                        if (products[key].variants[variantkey].available) {
                            if(String(products[key].variants[variantkey].title).toLowerCase().includes(String(searchesValue).toLowerCase().trim())){
                                product_Html = product_Html + `
                                    <li class="grid__item item-row wide--one-third post-large--one-third large--one-third medium--one-half small--one-half  medium--grid__item small-grid__item  " id="product-6190665990314">
                                        <div class="products product-hover-11">
                                            <div class="product-container">
                                                <a href="/products/${products[key].handle}?variant=${products[key].variants[variantkey].id}" class="grid-link">
                                                    <div class="ImageOverlayCa"></div>
                                                </a>
                                                <div class="reveal"><a href="/products/${products[key].handle}?variant=${products[key].variants[variantkey].id}" class="grid-link"> 
                                                    <span class="product-additional">   
                                                    </span></a><a href="/products/${products[key].handle}?variant=${products[key].variants[variantkey].id}" class="grid-link">  
                                                    <img src="${products[key].variants[variantkey].featured_image.src}" class="featured-image" alt="Black">
                                                    </a>
                                                    <a href="/products/${products[key].handle}?variant=${products[key].variants[variantkey].id}" class="grid-link">  
                                                    <img src="${products[key].images[1].src}" class="hidden-feature_img" alt="${products[key].variants[variantkey].title}">
                                                    </a>
                                                </div>
                                                <div class="product_right_tag  ">
                                                </div>
                                                <div class="ImageWrapper">
                                                    <div class="link_icon">
                                                    </div>
                                                    <div class="product-button"> 
                                                    <a title="Product Link" href="/products/${products[key].handle}?variant=${products[key].variants[variantkey].id}">                      
                                                    <i class="fas fa-link"></i> 
                                                    </a>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="product-detail">
                                                <a href="/products/${products[key].handle}?variant=${products[key].variants[variantkey].id}" class="grid-link__title" style="font-size: 90%">${products[key].title}</a>
                                                <a href="/products/${products[key].handle}?variant=${products[key].variants[variantkey].id}" class="grid-link__title">${products[key].variants[variantkey].title}</a>
                                                <span class="shopify-product-reviews-badge" data-id="6190665990314"></span>              
                                                <div class="grid-link__meta">
                                                    <div class="product_price">
                                                    <div class="grid-link__org_price" id="ProductPrice">
                                                        $${products[key].variants[variantkey].price}
                                                    </div>
                                                    </div>
                                                </div>
                                                <ul class="item-swatch">
                                                 
                                                </ul>
                                            </div>
                                        </div>
                                    </li>
                                    `;
                            }    
                        }
                    }
                }
            }
        }else {
            console.log('Else Statment');
            for(let k = 0; k < searchesValue.length; k++){
                console.log(searchesValue[k]);
                for (const key in products) {
                    for (const variantkey in products[key].variants) {
                        if (products[key].variants[variantkey].available) {
                            if(String(products[key].variants[variantkey].title).toLowerCase().includes(String(searchesValue[k]).toLowerCase().trim())){
                                product_Html = product_Html + `
                                    <li class="grid__item item-row wide--one-third post-large--one-third large--one-third medium--one-half small--one-half  medium--grid__item small-grid__item  " id="product-6190665990314">
                                        <div class="products product-hover-11">
                                            <div class="product-container">
                                                <a href="/products/${products[key].handle}?variant=${products[key].variants[variantkey].id}" class="grid-link">
                                                    <div class="ImageOverlayCa"></div>
                                                </a>
                                                <div class="reveal"><a href="/products/${products[key].handle}?variant=${products[key].variants[variantkey].id}" class="grid-link"> 
                                                    <span class="product-additional">   
                                                    </span></a><a href="/products/${products[key].handle}?variant=${products[key].variants[variantkey].id}" class="grid-link">  
                                                    <img src="${products[key].variants[variantkey].featured_image.src}" class="featured-image" alt="Black">
                                                    </a>
                                                    <a href="/products/${products[key].handle}?variant=${products[key].variants[variantkey].id}" class="grid-link">  
                                                    <img src="${products[key].images[1].src}" class="hidden-feature_img" alt="${products[key].variants[variantkey].title}">
                                                    </a>
                                                </div>
                                                <div class="product_right_tag  ">
                                                </div>
                                                <div class="ImageWrapper">
                                                    <div class="link_icon">
                                                    </div>
                                                    <div class="product-button"> 
                                                    <a title="Product Link" href="/products/${products[key].handle}?variant=${products[key].variants[variantkey].id}">                      
                                                    <i class="fas fa-link"></i> 
                                                    </a>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="product-detail">
                                                <a href="/products/${products[key].handle}?variant=${products[key].variants[variantkey].id}" class="grid-link__title" style="font-size: 90%">${products[key].title}</a>
                                                <a href="/products/${products[key].handle}?variant=${products[key].variants[variantkey].id}" class="grid-link__title">${products[key].variants[variantkey].title}</a>
                                                <span class="shopify-product-reviews-badge" data-id="6190665990314"></span>              
                                                <div class="grid-link__meta">
                                                    <div class="product_price">
                                                    <div class="grid-link__org_price" id="ProductPrice">
                                                        $${products[key].variants[variantkey].price}
                                                    </div>
                                                    </div>
                                                </div>
                                                <ul class="item-swatch">
                                                 
                                                </ul>
                                            </div>
                                        </div>
                                    </li>
                                    `;
                            }    
                        }
                    }
                }
            }
        }
      }


        if(String(product_Html).trim().length){
            document.getElementById('search_product_result').innerHTML = product_Html;
        }else {
            document.getElementById('search_product_result').innerHTML = `<h1> No Result Found </h1>`;
        }

      $(document).ready(function() {
          $(".item-swatch").each(function(){ 
          if($(this).children().length == 0){ 
              $(this).remove();        
              } else{
              $(this).show();        
              }
          });
          $(".sizes-list").each(function(){ 
          if($(this).children().length == 0){ 
              $(this).remove();        
              } else{
              $(this).show();        
              }
          });
      });
      //console.log();
      searchIocn.click();
  });



    //     for (const optionkey in products[key].options) {
                    //         if(products[key].options[optionkey].name == 'Color' || products[key].options[optionkey].name == 'color'){
                    //             window.CurrenColor = products[key].options[optionkey].values;
                    //             window.colorIndex = Number(optionkey) + 1;
                    //     }
                    //     }
                    //     for (const optionkey in products[key].options) {
                    //         console.log(products[key].options[optionkey]);
                    //         if(products[key].options[optionkey].name == 'Size' || products[key].options[optionkey].name == 'size'){
                    //             window.sizeIndex = Number(optionkey) + 1;
                    //             window.SizeIndex = optionkey + 1;
                    //             for(let x = 0; x < products[key].options[optionkey].values.length; x++){
                    //                 if(String(products[key].options[optionkey].values[x]).toLowerCase().includes(String(searchesValue[k]).toLowerCase().trim())){
                    //                     product_Html = product_Html + `
                    //                     <li class="grid__item item-row wide--one-third post-large--one-third large--one-third medium--one-half small--one-half  medium--grid__item small-grid__item  " id="product-6190665990314">
                    //                         <div class="products product-hover-11">
                    //                             <div class="product-container">
                    //                                 <a href="/products/${products[key].handle}" class="grid-link">
                    //                                     <div class="ImageOverlayCa"></div>
                    //                                 </a>
                    //                                 <div class="reveal"><a href="${products[key].handle}" class="grid-link"> 
                    //                                     <span class="product-additional">   
                    //                                     </span></a><a href="${products[key].handle}" class="grid-link">  
                    //                                     <img src="${products[key].images[0].src}" class="featured-image" alt="Black">
                    //                                     </a>
                    //                                     <a href="${products[key].handle}" class="grid-link">  
                    //                                     <img src="${products[key].images[1].src}" class="hidden-feature_img" alt="${products[key].title} - ${searchesValue[k]}">
                    //                                     </a>
                    //                                 </div>
                    //                                 <div class="product_right_tag  ">
                    //                                 </div>
                    //                                 <div class="ImageWrapper">
                    //                                     <div class="link_icon">
                    //                                     </div>
                    //                                     <div class="product-button"> 
                    //                                     <a title="Product Link" href="/products/${products[key].handle}">                      
                    //                                     <i class="fas fa-link"></i> 
                    //                                     </a>
                    //                                     </div>
                    //                                 </div>
                    //                             </div>
                    //                             <div class="product-detail">
                    //                                 <a href="${products[key].handle}" class="grid-link__title">${products[key].title} - ${searchesValue[k]}</a>
                    //                                 <span class="shopify-product-reviews-badge" data-id="6190665990314"></span>              
                    //                                 <div class="grid-link__meta">
                    //                                     <div class="product_price">
                    //                                     <div class="grid-link__org_price" id="ProductPrice">
                    //                                         $${products[key].variants[0].price}
                    //                                     </div>
                    //                                     </div>
                    //                                 </div>
                    //                                 <ul class="item-swatch">
                    //                                     ${window.CurrenColor ? window.CurrenColor.map((item, index) => {
                    //                                         if(index <= 3) {
                    //                                             for (const varkey in products[key].variants) {
                    //                                                 console.log(item, searchesValue);
                    //                                                 console.log(String(products[key].variants[varkey][`option${window.colorIndex}`]), String(products[key].variants[varkey][`option${window.sizeIndex}`]));
                    //                                                 if(String(products[key].variants[varkey][`option${window.colorIndex}`]).toLowerCase().includes(String(item).toLowerCase()) && String(products[key].variants[varkey][`option${window.sizeIndex}`]).toLowerCase().includes(String(searchesValue[k]).toLowerCase().trim())){
                    //                                                     if(products[key].variants[varkey]){
                    //                                                         return `
                    //                                                             <li>
                    //                                                                 <div class="tooltip">
                    //                                                                     ${item}
                    //                                                                 </div>
                                                                
                    //                                                                 <label data-value="${item}" class="swatchimg" img="${products[key].variants[varkey].featured_image.src}" style="background-image: url(${products[key].variants[varkey].featured_image.src}); background-size: cover; background-position: center;"></label>
                    //                                                             </li>
                    //                                                         `;
                    //                                                     }
                    //                                                 }    
                    //                                             }
                    //                                         }
                                                            
                    //                                     }) : ''}
                    //                                     ${window.CurrenColor ? window.CurrenColor.length > 4 ? 
                    //                                         `<li class="item-swatch-more">
                    //                                             <a href="/products/${products[key].handle}" title="More Color">
                    //                                             + ${window.CurrenColor.length - 4}
                    //                                             </a>
                    //                                         </li>`
                    //                                         : '' : ''}
                    //                                 </ul>
                    //                             </div>
                    //                         </div>
                    //                     </li>
                    //                     `;
                    //                     console.log(products[key]);
                    //                 }
                    //             }
                    //         }
                    // }